import { Moon, Sun } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { getTheme, setTheme, type Theme } from "@/lib/theme";

export function ThemeToggle() {

    const [theme, setLocalTheme] = useState<Theme>(() => getTheme());

    const toggle = () => {

        const next = theme === "dark" ? "light" : "dark";
        setTheme(next);
        setLocalTheme(next);
    };

    return (
        <Button variant="ghost" size="icon" onClick={toggle} aria-label="Toggle theme">
            {theme === "dark" ? <Sun /> : <Moon />}
        </Button>
    );
}
